import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const WorkerPairForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'workerpair'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'foreman_id',
            label: 'scheduling.worker_pairs.foreman_label',
            type: 'dropdown',
            disabled_selected: 'scheduling.worker_pairs.foreman_disabled_selected',
            showSearch: true,

            // Own object key so the foreman options are not overwritten by the helper fetch
            apiRequest: [{
                endpoint: 'get_user_list',
                object: 'foreman_user',
                params: { is_active: true, field_access: true, exclude_light_license: true },
                useCache: false
            }],
            allowNoneOption: false,
            optionFormat: 'full_name',
            selectionFormat: 'full_name',
            helperText: 'scheduling.worker_pairs.foreman_helperText',
        },
        {
            name: 'helper_id',
            label: 'scheduling.worker_pairs.helper_label',
            type: 'dropdown',
            disabled_selected: 'scheduling.worker_pairs.helper_disabled_selected',
            showSearch: true,
            apiRequest: [{
                endpoint: 'get_user_list',
                object: 'user',
                params: { is_active: true, field_access: true },
                useCache: false
            }],
            allowNoneOption: false,
            optionFormat: 'full_name',
            selectionFormat: 'full_name',
            helperText: 'scheduling.worker_pairs.helper_helperText',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default WorkerPairForm;
